import { Button, Stack } from '@mui/material';

import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

type JointProceedButtonsProps = {
  onContinue: () => void;
  onNotNow: () => void;
  disabledContinue?: boolean;
};

export function JointProceedButtons({
  onContinue,
  onNotNow,
  disabledContinue,
}: JointProceedButtonsProps) {
  const { t } = useTranslate();
  return (
    <Stack spacing={2} width="100%">
      <Button
        {...getDataTestId(`account-type-continue-button`)}
        fullWidth
        disabled={disabledContinue}
        variant="outlined"
        onClick={onContinue}
      >
        {t('common.button.continue')}
      </Button>
      <Button
        {...getDataTestId(`account-type-not-now-button`)}
        fullWidth
        onClick={onNotNow}
        variant="outlined"
      >
        {t('common.button.notNow')}
      </Button>
    </Stack>
  );
}
